import { render, staticRenderFns } from "./providerPanel.vue?vue&type=template&id=33b97d09&"
import script from "./providerPanel.vue?vue&type=script&lang=js&"
export * from "./providerPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports